export const legacyMPC = {
  path: '/',
  component: () => import('@/layouts/legacyMPC.vue'),
  children: [
    {
      path: '/',
      name: 'SetNumber',
      component: () => import('@/views/IVR/legacy/SetNumber/SetNumber')
    },
    {
      path: '/Ok/:folio',
      name: 'Ok',
      component: () => import('@/views/IVR/legacy/PaymentStatus')
    },
    {
      path: '/APPin/:numberType/:clientId',
      name: 'AutoProfilePinNotificationData',
      component: () => import('@/views/IVR/legacy/SetNumber/AutoProfileToPinNotificationUpdateData')
    },
    {
      path: '/AutoProfile/:numberType/:clientId',
      name: 'AutoProfile',
      component: () => import('@/views/IVR/legacy/SetNumber/AutoProfileToInvoices')
    },
    {
      path: '/Terms',
      name: 'Terms',
      component: () => import('@/views/common/Views/Terms')
    },
    {
      path: '/BuyError',
      name: 'BuyError',
      component: () => import('@/views/IVR/legacy/Error/BuyError')
    },
    {
      path: 'MPC/Invoices',
      name: 'Invoices',
      component: () => import('@/views/IVR/legacy/Invoices')
    },
    {
      path: 'MPC/RecurringPaymentActivationToken',
      name: 'AffiliationResult',
      component: () => import('@/views/IVR/legacy/Recurrence/AffiliationResult')
    },
    {
      path: 'MPC/PaymentStatus/:folio',
      name: 'PaymentStatusMpc',
      component: () => import('@/views/IVR/legacy/PaymentStatus')
    },
    {
      path: 'MPC/CancelarRecurrencia',
      name: 'CancelRecurrence',
      component: () => import('@/views/IVR/legacy/Recurrence/CancelRecurrence')
    },
    {
      path: 'MPC/RecurrenciaActiva',
      name: 'HasActiveRecurrence',
      component: () => import('@/views/IVR/legacy/Recurrence/ActiveRecurrence')
    },
    {
      path: 'MPC/CambiarTarjeta',
      name: 'ChangeCard',
      component: () => import('@/views/IVR/legacy/Recurrence/ChangeCard')
    },
    {
      path: 'MPC/CambiarCorreo',
      name: 'ChangeEmail',
      component: () => import('@/views/IVR/legacy/Recurrence/ChangeEmail/ChangeEmail')
    },
    {
      path: '/mca/redirector',
      name: 'MCARedirector',
      component: () => import('@/views/IVR/MCA/Redirector.vue')
    },
    {
      path: 'Error',
      name: 'Error',
      component: () => import('@/views/common/legacyError')
    }
  ]
};

export const MPC = {
  path: '/',
  component: () => import('@/layouts/MPC.vue'),
  children: [
    {
      path: '/',
      name: 'SetNumber',
      component: () => import('@/views/IVR/SetNumber.vue')
    },
    {
      path: '/Ok/:folio',
      name: 'Ok',
      component: () => import('@/views/IVR/PaymentStatus')
    },
    {
      path: '/APPin/:numberType/:clientId',
      name: 'AutoProfilePinNotificationData',
      component: () => import('@/views/IVR/legacy/SetNumber/AutoProfileToPinNotificationUpdateData')
    },
    {
      path: '/AutoProfile/:numberType/:clientId',
      name: 'AutoProfile',
      component: () => import('@/views/IVR/legacy/SetNumber/AutoProfileToInvoices')
    },
    {
      path: '/Terms',
      name: 'Terms',
      component: () => import('@/views/Terms')
    },
    {
      path: '/BuyError',
      name: 'BuyError',
      component: () => import('@/views/common/ErrorView'),
      props: { defaultError: 'DECLINED_TRANSACTION' }
    },
    {
      path: 'MPC/Invoices',
      name: 'Invoices',
      component: () => import('@/views/IVR/Invoices')
    },
    {
      path: 'MPC/RecurringPaymentActivationToken',
      name: 'AffiliationResult',
      component: () => import('@/views/IVR/Recurrence/AffiliationResult')
    },
    {
      path: 'MPC/PaymentStatus/:folio',
      name: 'PaymentStatusMpc',
      component: () => import('@/views/IVR/PaymentStatus')
    },
    {
      path: 'MPC/CancelarRecurrencia',
      name: 'CancelRecurrence',
      component: () => import('@/views/IVR/Recurrence/CancelRecurrence')
    },
    {
      path: 'MPC/RecurrenciaActiva',
      name: 'HasActiveRecurrence',
      component: () => import('@/views/IVR/Recurrence/ActiveRecurrence')
    },
    {
      path: 'MPC/CambiarTarjeta',
      name: 'ChangeCard',
      component: () => import('@/views/IVR/legacy/Recurrence/ChangeCard')
    },
    {
      path: 'MPC/CambiarCorreo',
      name: 'ChangeEmail',
      component: () => import('@/views/IVR/Recurrence/ChangeEmail/ChangeEmail')
    },
    {
      path: '/mca/redirector',
      name: 'MCARedirector',
      component: () => import('@/views/IVR/MCA/Redirector.vue')
    },
    {
      path: '/Error',
      name: 'Error',
      component: () => import('@/views/common/ErrorView')
    }
  ]
};
